import { FaArrowRight } from "react-icons/fa";
import "./CTA.css";

const CTA = () => {
  return (
    <section className="uniq-oglitz-cta">
      <div className="uniq-oglitz-cta__container">
        <span className="uniq-oglitz-cta__badge">
          Let’s Build Something Exceptional
        </span>

        <h2>
          Ready to Start Your <span>Next Digital Project?</span>
        </h2>

        <p>
          Partner with a global software team delivering scalable web, mobile,
          and enterprise solutions across India, Dubai, and worldwide.
        </p>

        <div className="uniq-oglitz-cta__actions">
          <a href="/start-project" className="uniq-oglitz-cta__btn primary">
            Start a Project <FaArrowRight />
          </a>

          <a href="/contact" className="uniq-oglitz-cta__btn secondary">
            Talk to an Expert
          </a>
        </div>

        <div className="uniq-oglitz-cta__trust">
          Trusted by startups, enterprises & global brands
        </div>
      </div>
    </section>
  );
};

export default CTA;
